module.exports = __webpack_public_path__ + "img/icon_finger@2x.b7d5e1eb.png";